import { fetch } from '@/commons/fetch'
import { requestUrl } from '@/commons/config'
import {calendarHeaders} from '@/commons/headers'
// state
const state = {
  stockAffect: {}
}

// getters
const getters = {
  stockAffect: state => state.stockAffect
}

// actions
const actions = {
  getStockAffect ({commit}, date = '') {
    console.log(date)
    return new Promise((resolve, reject) => {
      this.isLoading = true
      fetch({
        url: requestUrl.rili.stockAffect,
        params: {
          date
        },
        headers: calendarHeaders,
        type: 'GET',

        useJson: true,
        // jsonpCallback: 'callback',
        callback: ({ data }) => {
          commit('SET_STOCK_AFFECT', data)
          resolve(data)
        },
        success: ({ data }) => {
          commit('SET_STOCK_AFFECT', data)
          resolve(data)
        },
        error: () => {
          reject()
        }
      })
    })
  }
}
// mutations
const mutations = {
  SET_STOCK_AFFECT (state, data) {
    state.stockAffect = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js